import apiClient from "../client.js";
import { API_URLS } from "../urls.js";

// Get all leads
export const getLeads = () => apiClient.get(API_URLS.LEADS.LIST);

// Get single lead
export const getLead = (id) => apiClient.get(API_URLS.LEADS.DETAIL(id));

// Export leads
export const exportLeads = () =>
    apiClient.get(API_URLS.LEADS.EXPORT, {
      responseType: "blob",
      transformResponse: [(data) => data], // 🔥 prevents interceptor transform issues
    });

export const resendLead = (id) => apiClient.post(API_URLS.LEADS.RESEND(id));

export const resetLeadStatus = (id) => apiClient.post(API_URLS.LEADS.RESET_STATUS(id));